import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Link, Paper, Stack, Typography } from '@mui/material';
import Leaderboard from '../components/Leaderboard';
import { useLang } from '../i18n';

const STEPS = [
  {
    icon: '📘', title: 'Corso', to: '/course',
    text: "17 lezioni dal livello zero all'A2: alfabeto, verbi, i sei casi, l'aspetto, i verbi di moto, "
      + "l'imperativo e il condizionale. Ogni lezione ha una breve grammatica in italiano, parole e frasi con l'accento segnato.",
  },
  {
    icon: '🇷🇺', title: 'Lezione', to: '/study',
    text: "Il cuore dell'app. Prima di ogni nuova lezione leggi la grammatica, poi parole, coniugazioni ed esercizi. "
      + 'Scrivi tu la risposta: il sistema ricorda gli errori e decide da solo quando ripassare.',
  },
  {
    icon: '📈', title: 'Progressi', to: '/progress',
    text: 'Serie di giorni, minuti, precisione e avanzamento nelle lezioni. Lì imposti anche il tuo obiettivo giornaliero.',
  },
];

export default function HomeIt({ userName, isAuthenticated }) {
  const { setLang } = useLang();
  return (
    <Container maxWidth="md">
      <Box sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'stretch', p: { xs: 2, sm: 4 },
        boxShadow: 3, borderRadius: 2, backgroundColor: 'background.paper',
      }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'center' }}>
          Приве́т{userName ? `, ${userName}` : ''}! 👋
        </Typography>
        <Typography variant="body1" paragraph sx={{ textAlign: 'center' }}>
          Memo — il russo da zero, un po' ogni giorno 🇷🇺
        </Typography>

        {isAuthenticated ? (
          <Stack spacing={2} sx={{ mb: 3 }}>
            <Button component={RouterLink} to="/study" variant="contained" size="large">🇷🇺 Inizia la lezione</Button>
            <Leaderboard />
          </Stack>
        ) : (
          <>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 1, justifyContent: 'center' }}>
              <Button component={RouterLink} to="/register" variant="contained" size="large">✍️ Registrati</Button>
              <Button component={RouterLink} to="/login" size="large">🔐 Accedi</Button>
            </Stack>
            <Typography variant="body2" lang="ru" sx={{ mb: 3, textAlign: 'center' }}>
              <Link component="button" onClick={() => setLang('ru')}>🇷🇺 Русская версия — учу итальянский</Link>
            </Typography>
          </>
        )}

        <Typography variant="h6" gutterBottom>🤔 Come funziona</Typography>
        <Stack spacing={1.5} sx={{ mb: 3 }}>
          {STEPS.map((step) => (
            <Box key={step.to}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {step.icon}{' '}
                <Link component={RouterLink} to={isAuthenticated ? step.to : '/register'}>{step.title}</Link>
              </Typography>
              <Typography variant="body2">{step.text}</Typography>
            </Box>
          ))}
        </Stack>

        <Paper variant="outlined" sx={{ p: 2, mb: 3, borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom>⌨️ Cirillico o lettere latine?</Typography>
          <Typography variant="body2" paragraph>
            Puoi rispondere in cirillico o in lettere latine (privet, spasibo): il sistema capisce entrambe.
            Gli accenti e la differenza tra е ed ё non contano.
          </Typography>
          <Typography variant="body2">
            Consiglio: aggiungi la tastiera russa al telefono (Impostazioni → Tastiere): dopo poche lezioni
            scriverai in cirillico senza pensarci.
          </Typography>
        </Paper>

        <Typography variant="h6" gutterBottom>📚 Consigli</Typography>
        <Typography variant="body2" paragraph>
          <strong>Un po' ogni giorno.</strong> 15–20 minuti al giorno valgono più di un'ora alla settimana:
          la serie di giorni ti aiuta a non mollare. Va benissimo anche dal telefono, sull'autobus.
        </Typography>
        <Typography variant="body2" paragraph>
          <strong>Ascolta.</strong> Dopo ogni risposta puoi sentire la pronuncia (🔊): la voce russa del telefono
          legge la parola giusta.
        </Typography>

        <Typography variant="h6" gutterBottom>📝 Condizioni d'uso</Typography>
        <Typography variant="body2" paragraph>
          Per qualsiasi domanda scrivi a <Link href="mailto:boris@shbb.pro">boris@shbb.pro</Link>.
          Non usiamo analytics di terze parti né tracker. Leggi le{' '}
          <Link component={RouterLink} to="/terms-of-service">condizioni d'uso</Link>.
        </Typography>
      </Box>
    </Container>
  );
}
